import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './TabBox.scss';

export default class TabBox extends Component {
  static propTypes = {
    children: PropTypes.node,
    selected: PropTypes.number,
    onTabChange: PropTypes.func,
    className: PropTypes.string
  };

  static defaultProps = {
    selected: 0
  };

  get tabWidth() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    let tabWidth = 100 / this.props.children.length;

    if (Math.round(tabWidth) !== tabWidth) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      tabWidth = tabWidth.toFixed(5);
    }

    return tabWidth;
  }

  render() {
    const { children, className, onTabChange: _, ...props } = this.props;
    const componentClassName = classNames('tab-box__wrapper', className);

    return (
      <div {...props} className={componentClassName}>
        <div className="tab-box">
          {React.Children.map(children, this.renderChildren)}
        </div>
      </div>
    );
  }

  renderChildren = (element, i) => {
    const tabWidth = this.tabWidth;
    const { selected, onTabChange } = this.props;

    return (
      <Fragment>
        <label
          onClick={() => onTabChange(i)}
          htmlFor={`tab-${i}`}
          tabIndex={i}
          className="tab-panel__label"
          style={{ width: `${tabWidth}%`, left: `${i * tabWidth}%` }}
        />
        <input
          id={`tab-${i}`}
          type="radio"
          name="tabs"
          checked={selected === i}
          aria-hidden="true"
          readOnly
        />
        <h2
          className="tab-panel__title"
          style={{ width: `${tabWidth}%`, left: `${i * tabWidth}%` }}
        >
          <I18n label={element.props.title} />
        </h2>
        <div className="tab-panel__content">{React.cloneElement(element)}</div>
      </Fragment>
    );
  };
}
